import { Switch, Route } from "react-router-dom";
import HomePage from "../Pages/Home.jsx";
import SearchPage from "../Pages/SearchPage.jsx";
import About from "../Pages/about.jsx";
import Login from "../Pages/Login.jsx";
import useScrollToTop from "../Hooks/useScrollToTop";
import ResetPassword from "../components/Authentication/ResetPassword.jsx";
import ForgetPassword from "../components/Authentication/ForgetPassword.jsx";
import PrivacyPolicy from "../Pages/PrivacyPolicy.jsx";
import TermsOfService from "../Pages/TermsOfService.jsx";
import EventDetailsPage from "../Pages/EventDetails.jsx";
import SpacePage from "../Pages/SpacePage.jsx";
import EventSpacesPage from "../Pages/Event&SpacesPage.jsx";
import PartnerLandingPage from "../Pages/PartnerLandingPage.jsx";
import CreativeProductEvolution from "../Pages/Magic.jsx";
import Custom404 from "../Pages/404.jsx";
import ProtectedRoute from "./ProtectedRoutes";
import ResearchPage from "../Pages/Research.jsx";
import ShopifyPage from "../Pages/Shopify.jsx";
// import CheckoutPage from "../Pages/Checkout.jsx";
import OrderDetailsPage from "../components/Profile/EventsAndSpaces/Orders/OrderDetailsPage.jsx";
import SettingsPage from "../Pages/Settings.jsx";

const AppRoutes = () => {
  useScrollToTop();
  return (
    <>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/search" exact component={SearchPage} />
        <Route path="/partner" exact component={PartnerLandingPage} />
        <Route path="/magic" exact component={CreativeProductEvolution} />
        <Route path="/about" exact component={About} />
        <Route path="/login" exact component={Login} />
        <Route path="/reset-password" exact component={ResetPassword} />
        <Route path="/forget-password" exact component={ForgetPassword} />
        <Route path="/policy" exact component={PrivacyPolicy} />
        <Route path="/terms" exact component={TermsOfService} />
        <Route path="/Research" exact component={ResearchPage} />
        <Route path="/shopify" exact component={ShopifyPage} />
        {/* <Route path="/checkout" exact component={CheckoutPage} /> */}

        {/* Protected Routes */}
        <ProtectedRoute path="/profile" exact component={EventSpacesPage} />
        <ProtectedRoute path="/settings" exact component={SettingsPage} />
        <ProtectedRoute
          path="/profile/orders/:orderId"
          exact
          component={OrderDetailsPage}
        />
        <ProtectedRoute
          path="/events/:eventName"
          exact
          component={EventDetailsPage}
        />
        <ProtectedRoute path="/spaces/:spaceName" exact component={SpacePage} />

        {/* Catch-all 404 route */}
        <Route path="*" exact component={Custom404} />
      </Switch>
    </>
  );
};

export default AppRoutes;
